import createHyphenator from 'hyphen';
import ptPatterns from 'hyphen/patterns/pt';
import esPatterns from 'hyphen/patterns/es';

const PATTERNS = {
  pt: createHyphenator(ptPatterns),
  es: createHyphenator(esPatterns),
};

function getHyphenator(locale) {
  return PATTERNS[locale] || PATTERNS.pt;
}

function joinSyllables(syllables, maxChars) {
  const parts = [];
  let current = '';

  syllables.forEach(syl => {
    if ((current + syl).length > maxChars && current) {
      parts.push(`${current}-`);
      current = syl;
    } else {
      current += syl;
    }
  });

  if (current) parts.push(current);

  return parts;
}

export function hyphenateWord(word, maxChars, locale = 'pt') {
  if (word.length <= maxChars) return [word];

  const hyphenated = getHyphenator(locale)(word);
  const syllables = hyphenated.split('\u00AD');

  return joinSyllables(syllables, maxChars);
}
